"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ExpandIcon = ({ className }) => {
    return (react_1.default.createElement("svg", { className: className, viewBox: "0 0 20 20" },
        react_1.default.createElement("path", { d: "M6 6L14 10L6 14V6Z", fill: "currentColor" })));
};
exports.default = ExpandIcon;
